export const eventData = {
  "North Cyprus": [
    {
      date: "May 17th-18th",
      time: "9 AM - 6 AM",
      eventName: "NTERNATIONAL IDEATORS CUP (IIC) Regional Round",
      contactNumber: "888-512-2168",
      venue: "CYPRUS AYDIN UNIVERSITY",
    },
  ],
  Malaysia: [
    {
      date: "3-June-2024",
      time: "9 AM - 10 AM",
      eventName: "Writers Guild (Creative writing)",
      contactNumber: "Announcing Soon",
      venue: "Announcing Soon",
    },
  ],
  Thailand: [
    {
      date: "3-July-2024",
      time: "9 AM - 10 AM",
      eventName: "Writers Guild (Creative writing)",
      contactNumber: "Announcing Soon",
      venue: "Announcing Soon",
    },
  ],
  Azerbaijan: [
    {
      date: "3-Oct-2024",
      time: "9 AM - 10 AM",
      eventName: "Writers Guild (Creative writing)",
      contactNumber: "Announcing Soon",
      venue: "Announcing Soon",
    },
  ],
  USA: [
    {
      date: "3-Nov-2024",
      time: "9 AM - 10 AM",
      eventName: "Writers Guild (Creative writing)",
      contactNumber: "Announcing Soon",
      venue: "Announcing Soon",
    },
  ],
  Pakistan: [
    {
      date: "3-Dec-2024",
      time: "9 AM - 10 AM",
      eventName: "Writers Guild (Creative writing)",
      contactNumber: "Announcing Soon",
      venue: "Announcing Soon",
    }
  ],
};

export const events = [
  {
    id: "creative-writing",
    title: "Writers Guild",
    image: "event-1.png",
    GuiSubHeading:
      "Judges will assess each submission based on the following factors:",
    GuidHeading: "Evaluation Criteria:",
    subtitle: "(Creative Writing)",
    description:
      "Unleash your creativity and showcase your writing skills in this exciting competition.",
    category: "Writers Guild (Creatvie Writing)",
    storytitle: "Writer’s Guild – Creative Writing Round",
    storyDescription:
      "The Writer’s Guild is the first stage of the International Ideators Cup (IIC), where participants embark on an individual creative writing challenge. While teams consist of three members, this round is judged on an individual basis, ensuring that each writer's creativity and originality shine independently.\n\nEach participant will receive a topic aligned with the yearly theme, carefully designed to spark imagination and critical thinking. With only 45 minutes to craft their piece, writers must construct a compelling 200 to 250-word essay that reflects their unique perspective. This round encourages participants to think quickly, structure their thoughts effectively, and engage their audience with well-developed narratives, arguments, or descriptions.",
    wordLimit: "200-250 Words",
    theme: "Coming Soon",
    format: "Individual Participants",
    date: "May 3rd, 2025",
    time: "9:00 AM - 10:00 AM",
    country: "North Cyprus",
    venue: "Girne",
    evaluationCriteria: [
      {
        description: "How uniquely does the writer approach the topic?",
      },
      {
        description:
          "Does the essay have a logical flow and clarity in expression?",
      },
      {
        description:
          "How well is the piece written in terms of language use, sentence structure, and vocabulary?",
      },
      {
        description:
          "Does the essay stay focused and aligned with the given prompt?",
      },
    ],
  },
  {
    id: "filming",
    GuiSubHeading:
      "Judges will assess each submission based on the following factors:",
    title: "The Narrative Quest",
    GuidHeading: "Guidelines for Narrative Quest:",
    storytitle: "Narrative Quest – Storytelling Round",
    storyDescription:
      "The Narrative Quest is a dynamic, team-based storytelling competition that puts creativity and critical thinking to the test. In this round, teams of three will be paired against another team in a shared space, with a judge overseeing the competition.\n\nEach team will receive an unfinished story related to the event’s theme and must work together to develop a compelling continuation. One team member will present the introduction, the second will deliver the main body, and the third will conclude the narrative. After both teams have presented their stories, they will engage in a cross-questioning session, challenging each other's storytelling choices and narrative structures\n\nTeams will have 15 minutes to prepare and 15 minutes to present. Judges will evaluate creativity, logical flow, storytelling skills, and the team’s ability to construct a well-developed and engaging narrative. This round not only tests storytelling but also encourages teamwork, improvisation, and the ability to defend creative choices.",

    subtitle: "(Story Telling)",
    description:
      "Create a short film and bring your story to life with visuals.",
    category: "The Narrative Quest",
    image: "event-2.png",
    wordLimit: "Write film duration 3-5 minutes ",

    theme: "Coming Soon",
    format: "Team Work",
    evaluationCriteria: [
      {
        description:
          "Teams will be paired in a shared space, with two teams per room.",
      },
      {
        description:
          "A judge will provide the unfinished story and supervise the round.",
      },
      {
        description:
          "Each team will have 15 minutes to prepare their version of the story.",
      },

      {
        description: "Presentations will be structured as follows",

        subdescription: [
          "First speaker: Introduction ",
          "Second speaker: Main body",
          "Third speaker: Conclusion",
        ],
      },
      {
        description:
          "After both teams present, they will cross-question each other about their story choices.",
      },
      {
        description:
          " Creativity, coherence, and engagement will determine the winners.",
      },
    ],
    date: "May 3rd, 2025",
    time: "9:00 AM - 10:00 AM",
    country: "North Cyprus",
    venue: "Girne",
  },
  {
    id: "storytelling",
    title: "The Big Picture",
    storytitle: "The Big Picture – Visual Essay Round",
    GuidHeading: "Key Requirements:",
    image: "event-3.jpg",
    subtitle: "(Visual Essay, Filmmaking)",

    storyDescription:
      "In The Big Picture, teams of three will transform ideas into powerful visual narratives. This round challenges participants to create a 3 to 5-minute visual essay on a given topic related to the yearly theme.\n\nUnlike the previous rounds, teams will receive their topic one day before the round, allowing them time to plan and execute their visual essay effectively. The final presentation should combine images, videos, text, voiceovers, and other multimedia elements to convey a strong, compelling message.\n\nJudges will assess the clarity of the argument, storytelling technique, creativity, technical execution, and overall impact. The Big Picture tests a team’s ability to synthesize ideas visually, making it a crucial step toward the final showdown.",
    description:
      "Tell a captivating story and engage your audience with words.",
    category: "The Big Picture",
    wordLimit: "3-5 Minutes",
    theme: "Coming Soon",
    format: "Team Work",
    evaluationCriteria: [
      {
        description: "Teams will receive their topic one day in advance.",
      },
      {
        description: "The visual essay must be 3 to 5 minutes long.",
      },
      {
        description:
          "It should effectively communicate ideas through a mix of visuals, text, and audio.",
      },
      {
        description:
          "Creativity, message clarity, and storytelling skills will be key evaluation criteria.",
      },
    ],
    date: "May 3rd, 2025",
    time: "9:00 AM - 10:00 AM",
    country: "North Cyprus",
    venue: "Girne",
  },
];
export const countryData = [
  { country: "North Cyprus", cities: ["Girne"] },
  { country: "Pakistan", cities: ["Lahore", "Karachi", "Islamabad"] },
  { country: "Azerbaijan", cities: ["Baku"] },
  { country: "Thailand", cities: ["Bangkok"] },
  { country: "Malaysia", cities: ["Kuala Lumpur"] },
];
